/**
 Created by xie.zhengyun  2019-07-16
 description: 租户成品配置 具体信息
**/
"use strict";
angular.module("configDetailModule", []).
directive("configDetail", ["trsHttpService", "$timeout", "trsspliceString", "$q", "$filter", function(trsHttpService, $timeout, trsspliceString, $q, $filter) {
    return {
        restrict: "EA",
        replace: false,
        //transclude: true,
        scope: {
            productId: "=",
        },
        link: function($scope, $elem, $attrs) {
            initStatus()
            initData()
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    temShowFlag: false,
                }
                $scope.data = {
                    filterList: []
                }
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                getRuleDetail().then(() => {
                    initMouseEnter();
                    initMouseLeave();
                    initDestroy();
                });
            }
            /**
             * [initDestroy description] 初始化销毁事件
             * @return {[type]} [description]
             */
            function initDestroy() {
                $scope.$on("$destroy", function() {
                    if (angular.isDefined($scope.status.$template)) {
                        $scope.status.$template.remove();
                    }
                });
            }
            /**
             * [initMouseEnter description] 初始化鼠标移入
             * @return {[type]} [description]
             */
            function initMouseEnter() {
                $elem.bind("mouseenter", function() {
                    if ($scope.data.rules.SHARETYPE == 1) {
                        $scope.status.$template = $(
                            [
                                "<div class='configDetail'>",
                                initElement($scope.data.rules.TENANTINFO),
                                "</div>"
                            ].join(""));
                    } else {
                        $scope.status.$template = $(
                            [
                                "<div class='smallConfigDetail'>",
                                $scope.data.rules.SHARETYPENAME,
                                "</div>"
                            ].join(""));
                    }
                    $(".tenantDataConfig").append($scope.status.$template);
                    correctDirection()
                    initTmpMouse()
                });

            }
            /**
             * [initTmpMouseEnter description] 初始化鼠标移入和移出
             */
            function initTmpMouse() {
                $('.configDetail').bind("mouseenter", function() {
                    $scope.status.showFlag = true;
                })
                $('.configDetail').bind("mouseleave", function() {
                    $(".tenantDataConfig").find(".configDetail").remove();
                    $scope.status.showFlag = false;
                })
                $('.smallConfigDetail').bind("mouseenter", function() {
                    $scope.status.showFlag = true;
                })
                $('.smallConfigDetail').bind("mouseleave", function() {
                    $(".tenantDataConfig").find(".smallConfigDetail").remove();
                    $scope.status.showFlag = false;
                })
            }
            /**
             * [initElement description] 生成元素
             */
            function initElement(tplData) {
                return tplData.map(function(item, index) {
                    return "<div class='config_item' >" +
                        "<div class='num_box'>" + (index + 1) + "</div>" +
                        "<p>共享租户：" + trsspliceString.spliceString(item.Tenants, "TenantName", "、") + "</p>" +
                        "<p>共享时间：" + $filter('date')(item.BeginDate, 'yyyy-MM-dd') + "<span class='separator'>-</span>" + $filter('date')(item.EndDate, 'yyyy-MM-dd') + "</p>" +
                        "</div>";
                }).join("");
            }
            /**
             * [getRuleDetail description] 获取共享规则详情
             * @return {[type]} [description]
             */
            function getRuleDetail() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'mlf_tenantdatadivide',
                    methodname: 'queryRelByProductId',
                    ProductId: $scope.productId
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    $scope.data.rules = data;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [correctDirection description] 调整位置
             */
            function correctDirection() {
                var bodyHeight = $("body").height();
                var parentTop = $($elem).offset().top;
                var parentleft = $elem.offset().left;
                var templateWidth = $scope.status.$template.outerWidth(true);
                var templateHeight = $scope.status.$template.outerHeight(true);
                var leftWidth = $('.view_sidebar').outerWidth(true);
                // 判断下面能不能放下
                if (bodyHeight - parentTop < templateHeight) {
                    $scope.status.$template.css({ 'left': parentleft - templateWidth - leftWidth - 10, 'top': parentTop - templateHeight - 60 })
                } else {
                    $scope.status.$template.css({ 'left': parentleft - templateWidth - leftWidth - 10, 'top': parentTop - 70 })
                }
            }
            /**
             * [initMouseLeave description] 初始化鼠标移出
             * @return {[type]} [description]
             */
            function initMouseLeave() {
                $elem.bind("mouseleave", function() {
                    $timeout(() => {
                        if (!$scope.status.showFlag) {
                            $(".tenantDataConfig").find(".configDetail").remove();
                            $(".tenantDataConfig").find(".smallConfigDetail").remove();
                        }
                    }, 20)
                });

            }


        }
    };
}]);